import type { ScreenModule } from "../../../app/screen-module";
import { DemoPage } from "../auth-pages";

export default {
	id: "public.demo",
	path: "/demo",
	area: "public",
	navGroup: "サービス案内",
	label: "デモ",
	roles: [],
	backing: "MOCK_ONLY",
	demo: { allowed: true, constraints: ["no-persist"] },
	enabled: true,
	component: DemoPage,
} satisfies ScreenModule;
